module.exports = __webpack_public_path__ + "static/media/support_07@2x.7ebc302f.png";